import { useSelector } from "react-redux";
import { getIntercomHmnac } from '@/services/user/security'
import { initIntercom } from '@/utils/intercom'
import useSettings from "./useSettings";

const useIntercom = () => {
  const { user } = useSelector(state => state?.user);
  const {settings} = useSettings();
  const getIntercomLanguage = () => {
    const language = settings?.lang || "en"
    if(language === 'cn'){
      return 'zh'
    } else if(language === 'hk'){
      return 'zh-TW'
    } 
    return language
  }
  const initService = (callback) => {
    if (user) {
      getIntercomHmnac().then(res => {
        initIntercom(user.uid, res)
        callback && callback();
      })
    }
  }
  const showIntercom = () => {
    const lang = getIntercomLanguage()
    if (window.Intercom) {
      setIntercomLanguage(lang)
      window.Intercom('show')
    }else{
      initService(() => {
        setIntercomLanguage(lang)
        window.Intercom('show')
      })
    }
  }
  const setIntercomLanguage = (lang) => {
    if (window.Intercom) {
      window.Intercom('update', {
        language_override: lang
      })
    }
  }
  return {
    initService,
    showIntercom,
    setIntercomLanguage
  };
};

export default useIntercom;